import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import VerticalNavigator from "@/layouts/vertical_navigator.vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'page_not_found',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("h1", null, " Page Not Found ", -1),
          _createElementVNode("p", null, " Server could not find requested page. ", -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})